/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { StakeRewards } from "../StakeRewards";

export class StakeRewards__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<StakeRewards> {
    return super.deploy(overrides || {}) as Promise<StakeRewards>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): StakeRewards {
    return super.attach(address) as StakeRewards;
  }
  connect(signer: Signer): StakeRewards__factory {
    return super.connect(signer) as StakeRewards__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StakeRewards {
    return new Contract(address, _abi, signerOrProvider) as StakeRewards;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressAddedToWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "removedWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressRemovedFromWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "period",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
    ],
    name: "WithdrawRequested",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewards",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addAddressToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCI",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "start",
            type: "uint64",
          },
          {
            internalType: "uint16",
            name: "option",
            type: "uint16",
          },
          {
            internalType: "bool",
            name: "autorenew",
            type: "bool",
          },
          {
            internalType: "uint64",
            name: "end",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "requestedAt",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
        ],
        internalType: "struct StakeInfo",
        name: "s",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "total",
            type: "uint256",
          },
          {
            internalType: "uint128",
            name: "emission",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "index",
            type: "uint256",
          },
        ],
        internalType: "struct StakeOption",
        name: "opt",
        type: "tuple",
      },
    ],
    name: "calcRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "rewards",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "claimable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "withdrawable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "endOfLastPeriod",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
    ],
    name: "calcRewardsByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "rewards",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "claimable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "withdrawable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "endOfLastPeriod",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
    ],
    name: "calculateCumulativeIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "canEmergencyWithdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "cooldownPeriod",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
    ],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyWithdrawal",
    outputs: [
      {
        internalType: "bool",
        name: "withdrawalEnabled",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "startTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTimestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "freeAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStakeOptions",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "total",
            type: "uint256",
          },
          {
            internalType: "uint128",
            name: "emission",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "index",
            type: "uint256",
          },
        ],
        internalType: "struct StakeOption[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getUserStakes",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "lastCI",
            type: "uint256",
          },
          {
            internalType: "uint64",
            name: "start",
            type: "uint64",
          },
          {
            internalType: "uint16",
            name: "option",
            type: "uint16",
          },
          {
            internalType: "bool",
            name: "autorenew",
            type: "bool",
          },
          {
            internalType: "uint64",
            name: "end",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "requestedAt",
            type: "uint64",
          },
          {
            internalType: "uint256",
            name: "claimed",
            type: "uint256",
          },
        ],
        internalType: "struct StakeInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_whitelistAddresses",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_stakeToken",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_unlockTimestamp",
        type: "uint64",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastIndexTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "multipliers",
    outputs: [
      {
        internalType: "uint16[4]",
        name: "",
        type: "uint16[4]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "periods",
    outputs: [
      {
        internalType: "uint32[4]",
        name: "",
        type: "uint32[4]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeAddressFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
    ],
    name: "requestWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "withRewards",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
    ],
    name: "restake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "val",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "startTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTimestamp",
        type: "uint256",
      },
    ],
    name: "setEmergencyWithdrawal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newEmissionPerSecond",
        type: "uint256",
      },
    ],
    name: "setEmissionPerSecond",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
    ],
    name: "stakeFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stakeOptions",
    outputs: [
      {
        internalType: "uint256",
        name: "total",
        type: "uint256",
      },
      {
        internalType: "uint128",
        name: "emission",
        type: "uint128",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakeToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "stakeWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
    ],
    name: "switchAutorenew",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "weithedAmountSum",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalEmissionPerSecond",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalEmissionPerSecondVersion2",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalWeigthedAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "weithedAmountSum",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unlockTimestamp",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_timestamp",
        type: "uint64",
      },
    ],
    name: "updateUnlockTimestamp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "usersStake",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lastCI",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "start",
        type: "uint64",
      },
      {
        internalType: "uint16",
        name: "option",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
      {
        internalType: "uint64",
        name: "end",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "requestedAt",
        type: "uint64",
      },
      {
        internalType: "uint256",
        name: "claimed",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeIndex",
        type: "uint16",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawExtraTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawWindow",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
